import { GoogleLogo } from '@/components/pages/icons';
import { Star } from './star';

type GoogleReviewServerProps = {
  href: string;
  rating: number;
};

export function GoogleReviewServer({ href, rating }: GoogleReviewServerProps) {
  const safeRating = Math.max(0, Math.min(5, rating));

  return (
    <a
      href={href}
      target="_blank"
      className="bg-white w-fit h-fit rounded-lg overflow-hidden font-sans min-w-30 @lg:min-w-[164px]"
    >
      <div className="flex justify-center py-1 px-1.5 @lg:px-2 gap-1 @lg:gap-2">
        <div className="flex items-center justify-center shrink-0">
          <GoogleLogo className="w-5 h-5 @lg:w-8 @lg:h-8" />
        </div>

        <div className="flex flex-col">
          <span className="text-[9px] @lg:text-[10px] font-bold font-sans">Google Rating</span>

          <div className="flex items-center gap-1">
            <span className="text-xs @lg:text-base text-[#b85600] font-semibold leading-3 @lg:leading-4">
              {safeRating > 0 ? safeRating.toFixed(1) : '--'}
            </span>

            <div className="flex items-center">
              {[...Array(5)].map((_, index) => {
                const fillPercentage = Math.max(0, Math.min(100, (safeRating - index) * 100));
                return (
                  <Star
                    className="w-2.5 h-2.5 @lg:w-3.5 @lg:h-3.5 mr-0.5"
                    key={index}
                    index={index}
                    fillPercentage={fillPercentage}
                  />
                );
              })}
            </div>
          </div>

          <span className="text-[8px] @lg:text-[10px] text-black/60">See all our reviews</span>
        </div>
      </div>
    </a>
  );
}
